import React, { useState } from "react";
import { motion } from "framer-motion";
import axios from "axios";
import { toast } from "sonner";
import { Input } from "../ui/input";
import { Button } from "../ui/button";
import { API } from "../../lib/constants";

const TradeSectionComingSoon = () => {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${API}/trade-inquiries?email=${encodeURIComponent(email)}`);
      setSubmitted(true);
      toast.success("Thanks! We'll notify you when trade packages launch.");
    } catch (error) {
      toast.error("Something went wrong. Please try again.");
    }
  };

  return (
    <section className="section-spacing bg-slate-950" data-testid="trade-section">
      <div className="max-w-4xl mx-auto px-4 md:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="glass rounded-2xl p-8 md:p-12 text-center relative overflow-hidden"
        >
          <div className="absolute top-4 right-4 bg-cyan-400 text-slate-900 text-xs font-bold px-3 py-1 rounded-full">
            Coming Soon
          </div>
          
          <h2 className="text-2xl md:text-3xl font-bold mb-4">
            Trade & Business <span className="gradient-text">Packages</span>
          </h2>
          
          <p className="text-slate-400 mb-6">
            Special rates for Uber drivers, tradies, plumbers, and business fleets.<br />
            <span className="text-cyan-400">We bring our own water & power - visit you anywhere!</span>
          </p>

          {!submitted ? (
            <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto">
              <Input
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="bg-slate-800 border-slate-700 flex-1"
                data-testid="trade-email-input"
              />
              <Button 
                type="submit" 
                className="btn-primary-glow text-slate-900 font-semibold px-6"
                data-testid="trade-notify-btn"
              >
                Notify Me
              </Button>
            </form>
          ) : (
            <p className="text-green-400 font-medium">You're on the list! We'll be in touch soon.</p>
          )}
        </motion.div>
      </div>
    </section>
  );
};

export default TradeSectionComingSoon;
